import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faFile, faFolderUpload } from "@fortawesome/pro-regular-svg-icons";
import {
    faArrowToBottom,
    faCaretDown,
    faCaretRight,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { isEmpty } from "lodash";
import { useState } from "react";
import DocumentDto from "../../../../PaymentContainerClient/dtos/DocumentDto";
import getFormattedMessageWithScope from "../../../../utils/getFormattedMessageWithScope";
import { CustomButton } from "../../CustomButton";
import { useWindowDimensions } from "../../WindowDimensionsProvider";
import "./style.css";

const fm = getFormattedMessageWithScope("components.Summary.AttachedDocuments");

interface AttachedDocumentsProps {
    currentStep: number;
    documents?: DocumentDto[];
    documentIdDownloading?: string;
    hasNotificationForOnHoldPayments: boolean;
    hasNotificationForPaidRequest: boolean;
    isDownloading: boolean;
    isPaid: boolean;
    onDownloadDocument: Function;
}

export const AttachedDocuments = ({
    currentStep,
    documents,
    documentIdDownloading,
    hasNotificationForOnHoldPayments,
    hasNotificationForPaidRequest,
    isDownloading,
    isPaid,
    onDownloadDocument,
}: AttachedDocumentsProps) => {
    const { height } = useWindowDimensions();
    const [isOpen, setIsOpen] = useState(false);

    function toggleDocuments() {
        setIsOpen(!isOpen);
    }

    return documents && !isEmpty(documents) && height > 705 ? (
        <div
            className={classNames(
                "c-Summary-attached-documents",
                currentStep === 0
                    ? "c-Summary-attached-documents-step-0"
                    : undefined,
                currentStep !== 0
                    ? "c-Summary-attached-documents-step-not-0"
                    : undefined,
                hasNotificationForOnHoldPayments
                    ? "c-Summary-attached-documents-with-onHold-notification"
                    : undefined,
                hasNotificationForPaidRequest
                    ? "c-Summary-attached-documents-with-paidRequest-notification"
                    : undefined
            )}
        >
            <div className="c-Summary-attached-documents-header">
                <div className="c-Summary-attached-documents-header-arrow-icon-container">
                    <FontAwesomeIcon
                        icon={(isOpen ? faCaretDown : faCaretRight) as IconProp}
                        className="c-Summary-attached-documents-header-arrow-icon"
                        onClick={toggleDocuments}
                    />
                </div>
                <FontAwesomeIcon
                    icon={faFolderUpload as IconProp}
                    className="c-Summary-attached-documents-header-folder-icon"
                />
                <span className="c-Summary-attached-documents-header-title">
                    {fm("attachedDocuments")}
                </span>
                <span className="c-Summary-attached-documents-header-documents-number">
                    {documents.length}
                </span>
            </div>
            {isOpen ? (
                <div
                    className={classNames(
                        "c-Summary-attached-documents-content",
                        currentStep === 0
                            ? "c-Summary-attached-documents-content-step-0"
                            : undefined,
                        hasNotificationForOnHoldPayments
                            ? "c-Summary-attached-documents-content-with-onHold-notification"
                            : undefined,
                        hasNotificationForPaidRequest
                            ? "c-Summary-attached-documents-content-with-paidRequest-notification"
                            : undefined
                    )}
                >
                    {documents.map((doc, index) => (
                        <div
                            key={index}
                            className="c-Summary-attached-documents-content-document"
                        >
                            <div className="c-Summary-attached-documents-content-document-info">
                                <FontAwesomeIcon icon={faFile as IconProp} />
                                <span className="c-Summary-attached-documents-content-document-description">
                                    {doc.description}
                                </span>
                            </div>
                            <div>
                                <CustomButton
                                    kind="tertiary"
                                    onClick={() => onDownloadDocument(doc)}
                                    icon={
                                        <FontAwesomeIcon
                                            icon={faArrowToBottom as IconProp}
                                        />
                                    }
                                    loading={
                                        isDownloading &&
                                        doc.documentId === documentIdDownloading
                                    }
                                    tooltipText={
                                        !isPaid &&
                                        !doc.allowDownloadBeforePayment
                                            ? fm("downloadBoundToPayment")
                                            : undefined
                                    }
                                    disabled={
                                        isDownloading ||
                                        (!isPaid &&
                                            !doc.allowDownloadBeforePayment)
                                    }
                                />
                            </div>
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    ) : null;
};
